<div class="p-4 md:p-6 max-w-4xl mx-auto">
  <!-- Header -->
  <h1 class="text-2xl font-bold text-gray-800 flex items-center mb-6">
    <mat-icon style="color: #1C593D; margin-right: 8px;">tune</mat-icon>
    Parámetros Tasa Automática USDT
  </h1>

  <!-- Candado de edición (solo producción). Ver AdminEditPermissionsService -->
  <app-solo-lectura-banner *ngIf="!puedeEditar"
    detalle="La edición de los parámetros de tasa automática USDT está reservada al operador autorizado.">
  </app-solo-lectura-banner>

  <!-- Card formulario -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <!-- Card header -->
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">settings</mat-icon>
        Configuración de Parámetros
      </h2>
    </div>

    <!-- Card body -->
    <div class="p-5">
      <form [formGroup]="ratesForm" class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Valor Solvencia (ValueSL)</mat-label>
          <input matInput formControlName="valueSL" appOnlynumber matInputCommified type="text" placeholder="Value SL">
          <span matTextPrefix>CLP&nbsp;&nbsp;</span>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Valor liquidez (ValueLQ)</mat-label>
          <input matInput formControlName="valueLQ" appOnlynumber matInputCommified type="text" placeholder="Value LQ">
          <span matTextPrefix>USDT&nbsp;</span>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Descuento 1</mat-label>
          <input matInput formControlName="discount1" appOnlynumber [allowNegative]="true" type="text" placeholder="Discount 1">
          <span matTextPrefix>USDT&nbsp;</span>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Descuento 2</mat-label>
          <input matInput formControlName="discount2" appOnlynumber [allowNegative]="true" type="text" placeholder="Discount 2">
          <span matTextPrefix>USDT&nbsp;</span>
        </mat-form-field>

        <!-- Botones -->
        <div class="sm:col-span-2 flex flex-col sm:flex-row justify-center gap-3 mt-2">
          <button type="button" [disabled]="!puedeEditar"
            [style.opacity]="puedeEditar ? '1' : '0.5'"
            [style.cursor]="puedeEditar ? 'pointer' : 'not-allowed'" (click)="showConfirm()"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
            Actualizar
          </button>
          <button type="button" [disabled]="!puedeEditar"
            [style.opacity]="puedeEditar ? '1' : '0.5'"
            [style.cursor]="puedeEditar ? 'pointer' : 'not-allowed'" (click)="reset()"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">restart_alt</mat-icon>
            Restablecer
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Componente hijo -->
  <app-rate-update-type [showOnlyUSDT]="true" class="w-full"></app-rate-update-type>
</div>
